/**
 * UNKWN Upsell Modal System - FIXED VERSION
 * Fixed: 2026-01-27 - iOS Safari compatibility
 * Issue: Click handler wasn't preventing real event, only fake event
 */

(function() {
  'use strict';

  const UPSELL_CONFIG = {
    upsellProducts: ['unkwnpro-cyclone-clipper', 'unkwnpro-cyclone-trimmer', 'unkwn-airbrush'],
    storageKey: 'unkwn_upsell_tracking'
  };

  let globalBundleData = null;
  try {
    const dataEl = document.getElementById('upsell-data-global');
    if (dataEl) {
      globalBundleData = JSON.parse(dataEl.textContent);
      console.log('[UNKWN Upsell] Loaded global bundle data');
    }
  } catch (e) {
    console.error('[UNKWN Upsell] Failed to load global bundle data:', e);
  }

  let currentUpsellData = null;
  let modalElement = null;
  let isProcessing = false;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    modalElement = document.getElementById('upsell-modal');
    if (!modalElement) {
      console.log('[UNKWN Upsell] Modal element not found - upsell disabled');
      return;
    }

    if (modalElement.parentElement !== document.body) {
      document.body.appendChild(modalElement);
      console.log('[UNKWN Upsell] Modal moved to body');
    }

    // Submit event handler
    document.addEventListener('submit', handleFormSubmit, true);

    // FIXED: Click handler now properly checks and prevents BEFORE delegating
    document.addEventListener('click', handleButtonClick, true);

    // iOS Safari: Also handle touchend for better responsiveness
    document.addEventListener('touchend', handleTouchEnd, true);

    setupModalButtons();
    setupKeyboardHandlers();

    console.log('[UNKWN Upsell] Modal system initialized (fixed version)');
  }

  /**
   * FIXED: Check if click is on an upsell product FIRST, then prevent if needed
   */
  function handleButtonClick(evt) {
    const button = evt.target.closest('button[name="add"]');
    if (!button) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    const productForm = form.closest('product-form');
    if (!productForm) return;

    const upsellMarker = productForm.querySelector('.upsell-marker[data-upsell-enabled="true"]');
    if (!upsellMarker) return; // Not an upsell product - let normal flow continue

    const productHandle = upsellMarker.dataset.productHandle;
    if (!UPSELL_CONFIG.upsellProducts.includes(productHandle)) return;

    // This IS an upsell product - PREVENT the real event NOW
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    console.log('[UNKWN Upsell] Intercepted click for:', productHandle);

    // Load upsell data and show modal
    const productId = upsellMarker.dataset.productId;
    const upsellDataEl = document.getElementById('upsell-data-' + productId);
    
    if (!upsellDataEl) {
      console.error('[UNKWN Upsell] No upsell data found, falling back to normal add');
      addToCartFallback(form);
      return;
    }

    try {
      currentUpsellData = JSON.parse(upsellDataEl.textContent);
      const formData = new FormData(form);
      const formVariantId = formData.get('id');
      if (formVariantId && !currentUpsellData.productVariantId) {
        currentUpsellData.productVariantId = formVariantId;
      }
      showModal();
    } catch (e) {
      console.error('[UNKWN Upsell] Error parsing upsell data:', e);
      addToCartFallback(form);
    }
  }

  /**
   * iOS Safari touch handler - prevents 300ms delay issues
   */
  let lastTouchTime = 0;
  function handleTouchEnd(evt) {
    // Debounce to prevent double-firing with click
    const now = Date.now();
    if (now - lastTouchTime < 500) return;
    
    const button = evt.target.closest('button[name="add"]');
    if (!button) return;

    // Let click handler deal with it, but mark the time
    lastTouchTime = now;
  }

  /**
   * Handle form submission (backup for programmatic submits)
   */
  function handleFormSubmit(evt) {
    const form = evt.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;

    const productForm = form.closest('product-form');
    if (!productForm) return;

    const upsellMarker = productForm.querySelector('.upsell-marker[data-upsell-enabled="true"]');
    if (!upsellMarker) return;

    const productHandle = upsellMarker.dataset.productHandle;
    if (!UPSELL_CONFIG.upsellProducts.includes(productHandle)) return;

    const productId = upsellMarker.dataset.productId;
    const upsellDataEl = document.getElementById('upsell-data-' + productId);
    if (!upsellDataEl) return;

    try {
      currentUpsellData = JSON.parse(upsellDataEl.textContent);
      const formData = new FormData(form);
      const formVariantId = formData.get('id');
      if (formVariantId && !currentUpsellData.productVariantId) {
        currentUpsellData.productVariantId = formVariantId;
      }
    } catch (e) {
      console.error('[UNKWN Upsell] Error parsing upsell data:', e);
      return;
    }

    evt.preventDefault();
    evt.stopImmediatePropagation();
    showModal();
  }

  /**
   * Fallback: add to cart normally if upsell data fails
   */
  async function addToCartFallback(form) {
    try {
      const formData = new FormData(form);
      const variantId = formData.get('id');
      if (variantId) {
        await addToCart(variantId, 1);
        showSuccess('Added to cart!');
        refreshCart();
      }
    } catch (e) {
      console.error('[UNKWN Upsell] Fallback add failed:', e);
    }
  }

  function showModal() {
    if (!modalElement || !currentUpsellData) return;

    const titleEl = modalElement.querySelector('.upsell-modal__title');
    const imageEl = modalElement.querySelector('.upsell-modal__image');
    const bundleNameEl = modalElement.querySelector('.upsell-modal__bundle-name');
    const priceNewEl = modalElement.querySelector('.upsell-modal__price-new');
    const priceDiffEl = modalElement.querySelector('.upsell-modal__price-diff');
    const savingsEl = modalElement.querySelector('.upsell-modal__savings');
    const singleNameEl = modalElement.querySelector('.upsell-modal__single-name');
    const ultimateBtn = modalElement.querySelector('[data-action="add-ultimate"]');

    if (titleEl) titleEl.textContent = 'Get the Complete ' + currentUpsellData.singleProductName + ' Bundle';
    if (imageEl) {
      imageEl.src = currentUpsellData.bundleImage || '';
      imageEl.alt = currentUpsellData.bundleTitle;
    }
    if (bundleNameEl) bundleNameEl.textContent = currentUpsellData.bundleTitle;
    if (priceNewEl) priceNewEl.textContent = currentUpsellData.bundlePriceLocalized || formatMoney(currentUpsellData.bundlePrice);
    if (priceDiffEl) priceDiffEl.textContent = currentUpsellData.extraCost;
    if (savingsEl) savingsEl.innerHTML = '&#10003; ' + currentUpsellData.savings;

    // Populate bundle items
    const itemListEl = modalElement.querySelector('.upsell-modal__item-list');
    let bundleItems = currentUpsellData.bundleItems;

    if (!bundleItems && globalBundleData && currentUpsellData.productHandle) {
      const handle = currentUpsellData.productHandle;
      if (handle.includes('clipper')) bundleItems = globalBundleData.clipperBundleItems;
      else if (handle.includes('trimmer')) bundleItems = globalBundleData.trimmerBundleItems;
      else if (handle.includes('airbrush')) bundleItems = globalBundleData.airbrushBundleItems;
    }

    if (itemListEl && bundleItems && bundleItems.length > 0) {
      itemListEl.innerHTML = bundleItems.map(item =>
        '<li><span class="check-icon">✓</span> ' + item + '</li>'
      ).join('');
    }

    if (singleNameEl) singleNameEl.textContent = currentUpsellData.singleProductName;

    if (ultimateBtn) {
      if (currentUpsellData.showUltimate) {
        ultimateBtn.style.display = 'flex';
        const ultimatePriceEl = ultimateBtn.querySelector('.upsell-modal__cta-price');
        if (ultimatePriceEl) {
          ultimatePriceEl.textContent = currentUpsellData.ultimateBundlePriceLocalized || formatMoney(currentUpsellData.ultimateBundlePrice);
        }
      } else {
        ultimateBtn.style.display = 'none';
      }
    }

    modalElement.setAttribute('aria-hidden', 'false');
    modalElement.classList.add('upsell-modal--open');
    // Add price to green button
    try{var b=modalElement.querySelector('.upsell-modal__cta-primary .upsell-modal__cta-text');if(b&&currentUpsellData){var n=(currentUpsellData.singleProductName||'').toLowerCase();var t=n.includes('clipper')?'CLIPPER BUNDLE':n.includes('trimmer')?'TRIMMER BUNDLE':n.includes('airbrush')?'AIRBRUSH BUNDLE':'BUNDLE';var p=currentUpsellData.bundlePriceLocalized||'';b.textContent='\u2713 GET '+t+' \u2014 '+p;}}catch(e){}
    document.body.classList.add('upsell-modal-open');

    const firstButton = modalElement.querySelector('button, a');
    if (firstButton) firstButton.focus();

    trackUpsell('shown', {
      product: currentUpsellData.productHandle,
      bundle: currentUpsellData.bundleHandle,
      showUltimate: currentUpsellData.showUltimate
    });
  }

  function hideModal() {
    if (!modalElement) return;
    modalElement.setAttribute('aria-hidden', 'true');
    modalElement.classList.remove('upsell-modal--open');
    document.body.classList.remove('upsell-modal-open');
    isProcessing = false;
    resetButtons();
  }

  function setupModalButtons() {
    modalElement.querySelectorAll('[data-action="add-bundle"]').forEach(btn => {
      btn.addEventListener('click', handleAcceptUpsell);
    });
    modalElement.querySelectorAll('[data-action="add-ultimate"]').forEach(btn => {
      btn.addEventListener('click', handleUltimateUpsell);
    });
    modalElement.querySelectorAll('[data-action="add-single"]').forEach(btn => {
      btn.addEventListener('click', handleDeclineUpsell);
    });
    modalElement.querySelectorAll('[data-action="close-modal"]').forEach(el => {
      el.addEventListener('click', handleCloseModal);
    });
  }

  function setupKeyboardHandlers() {
    document.addEventListener('keydown', (evt) => {
      if (!modalElement.classList.contains('upsell-modal--open')) return;
      if (evt.key === 'Escape') {
        evt.preventDefault();
        handleCloseModal();
      }
    });
  }

  async function handleAcceptUpsell(evt) {
    evt.preventDefault();
    if (isProcessing || !currentUpsellData) return;
    isProcessing = true;
    setButtonLoading(true);

    try {
      if (requiresDelayedShippingModal('bundle')) {
        const confirmed = await showDelayedShippingModalAndWait('bundle', currentUpsellData.bundleVariantId);
        if (!confirmed) {
          isProcessing = false;
          setButtonLoading(false);
          return;
        }
      }

      await addToCart(currentUpsellData.bundleVariantId, 1);
      trackUpsell('accepted', { product: currentUpsellData.productHandle, bundle: currentUpsellData.bundleHandle });
      hideModal();
      showSuccess('Bundle added to cart!');
      refreshCart();
    } catch (error) {
      console.error('[UNKWN Upsell] Error adding bundle:', error);
      showError('Could not add to cart. Please try again.');
      isProcessing = false;
      setButtonLoading(false);
    }
  }

  async function handleUltimateUpsell(evt) {
    evt.preventDefault();
    if (isProcessing || !currentUpsellData) return;
    isProcessing = true;
    setButtonLoading(true, false, true);

    try {
      if (requiresDelayedShippingModal('ultimate')) {
        const confirmed = await showDelayedShippingModalAndWait('ultimate', currentUpsellData.ultimateBundleVariantId);
        if (!confirmed) {
          isProcessing = false;
          setButtonLoading(false);
          return;
        }
      }

      await addToCart(currentUpsellData.ultimateBundleVariantId, 1);
      trackUpsell('ultimate_accepted', { product: currentUpsellData.productHandle, bundle: currentUpsellData.ultimateBundleHandle });
      hideModal();
      showSuccess('Ultimate Bundle added to cart!');
      refreshCart();
    } catch (error) {
      console.error('[UNKWN Upsell] Error adding ultimate bundle:', error);
      showError('Could not add to cart. Please try again.');
      isProcessing = false;
      setButtonLoading(false);
    }
  }

  async function handleDeclineUpsell(evt) {
    evt.preventDefault();
    if (isProcessing || !currentUpsellData) return;
    isProcessing = true;
    setButtonLoading(true, true);

    try {
      await addToCart(currentUpsellData.productVariantId, 1);
      trackUpsell('declined', { product: currentUpsellData.productHandle, bundle: currentUpsellData.bundleHandle });
      hideModal();
      showSuccess('Added to cart!');
      refreshCart();
    } catch (error) {
      console.error('[UNKWN Upsell] Error adding product:', error);
      showError('Could not add to cart. Please try again.');
      isProcessing = false;
      setButtonLoading(false);
    }
  }

  function handleCloseModal(evt) {
    if (evt) evt.preventDefault();
    if (isProcessing) return;
    trackUpsell('closed', { product: currentUpsellData?.productHandle, bundle: currentUpsellData?.bundleHandle });
    hideModal();
  }

  async function addToCart(variantId, quantity = 1) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.description || 'Failed to add to cart');
    }
    return response.json();
  }

  function requiresDelayedShippingModal(bundleType) {
    const modalEl = document.getElementById('upsell-modal');
    if (!modalEl) return false;

    if (bundleType === 'ultimate') {
      return modalEl.dataset.ultimateBundleDelayed === 'true';
    } else {
      if (currentUpsellData.productHandle.includes('clipper')) {
        return modalEl.dataset.clipperBundleDelayed === 'true';
      } else if (currentUpsellData.productHandle.includes('trimmer')) {
        return modalEl.dataset.trimmerBundleDelayed === 'true';
      }
    }
    return false;
  }

  function showDelayedShippingModalAndWait(bundleType, variantId) {
    return new Promise((resolve) => {
      hideModal();

      if (window.DelayedShippingModal && window.DelayedShippingModal.showWithContext) {
        const duoVariantId = '45366825058361';
        const originalProductVariantId = currentUpsellData.productVariantId;
        const originalProductName = currentUpsellData.singleProductName || 'original product';

        window.DelayedShippingModal.showWithContext({
          source: 'upsell-upgrade',
          bundleVariantId: variantId,
          duoVariantId: duoVariantId,
          originalProductVariantId: originalProductVariantId,
          originalProductName: originalProductName
        });

        const confirmHandler = () => {
          document.removeEventListener('delayed-shipping:confirmed', confirmHandler);
          resolve(true);
        };
        const cancelHandler = () => {
          document.removeEventListener('delayed-shipping:cancelled', cancelHandler);
          showModal();
          resolve(false);
        };

        document.addEventListener('delayed-shipping:confirmed', confirmHandler, { once: true });
        document.addEventListener('delayed-shipping:cancelled', cancelHandler, { once: true });
      } else {
        resolve(true);
      }
    });
  }

  function setButtonLoading(loading, isDecline = false, isUltimate = false) {
    const primaryBtn = modalElement.querySelector('.upsell-modal__cta-primary');
    const ultimateBtn = modalElement.querySelector('.upsell-modal__cta-secondary');
    const declineLink = modalElement.querySelector('.upsell-modal__cta-decline');

    if (primaryBtn) {
      primaryBtn.disabled = loading;
      const textSpan = primaryBtn.querySelector('.upsell-modal__cta-text');
      const loadingSpan = primaryBtn.querySelector('.upsell-modal__cta-loading');
      if (textSpan) textSpan.style.display = loading && !isDecline && !isUltimate ? 'none' : '';
      if (loadingSpan) loadingSpan.style.display = loading && !isDecline && !isUltimate ? 'inline-flex' : 'none';
    }

    if (ultimateBtn) {
      ultimateBtn.disabled = loading;
      const textSpan = ultimateBtn.querySelector('.upsell-modal__cta-text');
      const priceSpan = ultimateBtn.querySelector('.upsell-modal__cta-price');
      const bestValueSpan = ultimateBtn.querySelector('.upsell-modal__cta-best-value');
      const loadingSpan = ultimateBtn.querySelector('.upsell-modal__cta-loading');
      if (loading && isUltimate) {
        if (textSpan) textSpan.style.display = 'none';
        if (priceSpan) priceSpan.style.display = 'none';
        if (bestValueSpan) bestValueSpan.style.display = 'none';
        if (loadingSpan) loadingSpan.style.display = 'inline-flex';
      } else {
        if (textSpan) textSpan.style.display = '';
        if (priceSpan) priceSpan.style.display = '';
        if (bestValueSpan) bestValueSpan.style.display = '';
        if (loadingSpan) loadingSpan.style.display = 'none';
      }
    }

    if (declineLink) {
      if (loading && isDecline) {
        declineLink.classList.add('loading');
        declineLink.textContent = 'Adding...';
      }
      declineLink.style.pointerEvents = loading ? 'none' : '';
    }
  }

  function resetButtons() {
    const primaryBtn = modalElement.querySelector('.upsell-modal__cta-primary');
    const declineLink = modalElement.querySelector('.upsell-modal__cta-decline');

    if (primaryBtn) {
      primaryBtn.disabled = false;
      const textSpan = primaryBtn.querySelector('.upsell-modal__cta-text');
      const loadingSpan = primaryBtn.querySelector('.upsell-modal__cta-loading');
      if (textSpan) textSpan.style.display = '';
      if (loadingSpan) loadingSpan.style.display = 'none';
    }

    if (declineLink && currentUpsellData) {
      declineLink.classList.remove('loading');
      declineLink.innerHTML = 'No thanks, just add the <span class="upsell-modal__single-name">' +
        (currentUpsellData.singleProductName || 'product') + '</span>';
      declineLink.style.pointerEvents = '';
    }
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.quantity-cart, .cart-count-bubble, [data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
          if (el.classList.contains('quantity-cart') || el.classList.contains('cart-count-bubble')) {
            el.style.display = cart.item_count > 0 ? '' : 'none';
          }
        });
      })
      .catch(err => console.error('[UNKWN Upsell] Error refreshing cart:', err));

    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(() => {
          fetch(window.Shopify.routes.root + '?sections=cart-notification-button,cart-notification-product,cart-icon-bubble')
            .then(r => r.json())
            .then(sections => {
              cartNotification.getSectionsToRender().forEach((section) => {
                const elementToReplace = document.getElementById(section.id);
                if (elementToReplace && sections[section.section]) {
                  const html = new DOMParser().parseFromString(sections[section.section], 'text/html');
                  const newContent = html.getElementById(section.id);
                  if (newContent) elementToReplace.innerHTML = newContent.innerHTML;
                }
              });
              cartNotification.open();
            });
        })
        .catch(err => console.error('[UNKWN Upsell] Error opening cart notification:', err));
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();

    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function formatMoney(cents) {
    const currencyConfig = window.unkwnCurrency && window.unkwnCurrency.config;
    if (currencyConfig && currencyConfig.moneyFormat) {
      const amount = (cents / 100).toFixed(2);
      return currencyConfig.moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function showSuccess(message) {
    console.log('[UNKWN Upsell]', message);
  }

  function showError(message) {
    console.error('[UNKWN Upsell]', message);
    alert(message);
  }

  function trackUpsell(eventType, data) {
    try {
      const tracking = JSON.parse(localStorage.getItem(UPSELL_CONFIG.storageKey) || '[]');
      tracking.push({ event: eventType, product: data.product, bundle: data.bundle, timestamp: new Date().toISOString() });
      localStorage.setItem(UPSELL_CONFIG.storageKey, JSON.stringify(tracking.slice(-100)));
    } catch (e) {}

    if (window.dataLayer) {
      window.dataLayer.push({ event: 'unkwn_upsell_' + eventType, upsell_product: data.product, upsell_bundle: data.bundle });
    }
    console.log('[UNKWN Upsell] Tracked:', eventType, data);
  }

  window.UNKWNUpsell = { showModal, hideModal, trackUpsell };
})();




